import(/* webpackMode: "eager" */ "/vercel/path0/components/atom/Container.js");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js")